export const useStyles = (theme) => ({
  gridItemRoot: {
    paddingLeft: 20,
    paddingBottom: 20,
    [theme.breakpoints.down(600)]: {
      paddingLeft: 0,
    },
  },
  paper: {
    padding: 20,
    display: "flex",
    flexDirection: "column",
  },
  bookCoverStyle: {
    paddingTop: 10,
    display: "flex",
    cursor: "pointer",
    justifyContent: "center",
    "&:hover": {
      opacity: 0.6,
    },
  },
  bookBody: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
  },
  buttonItem: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "flex-end",
  },
  coverImageStyle: {
    width: 200,
    height: 260,
    [theme.breakpoints.down("sm")]: {
      width: 250,
      height: 350,
    },
  },
  fabRoot: { backgroundColor: "#0a1f3a !important", width: 45, height: 45 },
});
